import { Box, Link, Typography, Divider } from '@mui/material';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import { LinkProps as MuiLinkProps } from '@mui/material/Link';

const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: 'auto',  // This pushes the footer to the bottom in a flex container
  marginBottom: theme.spacing(4),  // This adds spacing at the bottom
  padding: theme.spacing(3, 2),
  textAlign: 'center',
  backgroundColor: alpha(theme.palette.background.paper, 0.2),
  backdropFilter: 'blur(8px)',
  borderRadius: theme.shape.borderRadius,
}));

// Create a combined type for both MUI Link and Router Link props
interface FooterLinkProps extends MuiLinkProps {
  to?: RouterLinkProps['to'];
  component?: React.ElementType;
}

// Use the combined type for the styled component
const FooterLink = styled(Link)<FooterLinkProps>(({ theme }) => ({
  margin: theme.spacing(0, 1),
  transition: 'color 0.2s ease',
  '&:hover': {
    color: theme.palette.primary.light,
  }
}));

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <Box sx={{ mb: 1.5 }}>
        <FooterLink component={RouterLink} to="/about" color="primary" underline="hover">
          About
        </FooterLink>
        <FooterLink component={RouterLink} to="/privacy" color="primary" underline="hover">
          Privacy
        </FooterLink>
        <FooterLink component={RouterLink} to="/terms" color="primary" underline="hover">
          Terms
        </FooterLink>
      </Box>
      
      <Divider sx={{ width: '50%', mx: 'auto', mb: 1.5, opacity: 0.3 }} />
      
      <Typography variant="body2" color="text.secondary">
        © {currentYear} MailDerp. All emails are automatically deleted after 1 hour.
      </Typography>
    </FooterContainer>
  );
}

export default Footer;